import { useEffect, useRef, useState } from 'react';
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi';
import { MONTH_LABELS, formatPeriod } from '../../services/penetrationReportV2/periodUtils';
import { Period } from '../../services/penetrationReportV2/types';

interface MonthYearPickerProps {
  label: string;
  period: Period;
  onChange: (period: Period) => void;
}

function MonthYearPicker({ label, period, onChange }: MonthYearPickerProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [viewYear, setViewYear] = useState(period.year);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) setViewYear(period.year);
  }, [isOpen, period.year]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="pr2-date pr2-period-picker" ref={wrapperRef}>
      <button type="button" className="pr2-period-trigger" onClick={() => setIsOpen((open) => !open)}>
        <small>{label}</small>
        <strong>{formatPeriod(period)}</strong>
      </button>

      {isOpen && (
        <div className="pr2-period-popover">
          <div className="pr2-period-popover-year">
            <button type="button" onClick={() => setViewYear((y) => y - 1)} aria-label="Previous year">
              <HiOutlineChevronLeft />
            </button>
            <span>{viewYear}</span>
            <button type="button" onClick={() => setViewYear((y) => y + 1)} aria-label="Next year">
              <HiOutlineChevronRight />
            </button>
          </div>
          <div className="pr2-period-popover-months">
            {MONTH_LABELS.map((monthLabel, i) => {
              const month = i + 1;
              const isSelected = period.year === viewYear && period.month === month;
              return (
                <button
                  type="button"
                  key={monthLabel}
                  className={isSelected ? 'active' : ''}
                  onClick={() => { onChange({ year: viewYear, month }); setIsOpen(false); }}
                >
                  {monthLabel}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default MonthYearPicker;
